import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { updateStatusDocuments } from "../../../AdminAPI/UpdateStatusDocADM";
import { useTranslation } from "react-i18next";
import RelaunchToast from "./RelaunchToast";

const RelaunchDoc = ({ documentIds, documentData, onClose }) => {
  const [loading, setLoading] = useState(false);
  const token = Cookies.get("Token");

  const [currentStatus, setCurrentStatus] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [docList, setDocList] = useState([documentData.DocId]);
  const [errorMessage, setErrorMessage] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [nbModified, setNbModified] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
  setDocList(documentIds || []);

  if (documentData && documentData.length > 0) {
    const statuses = documentData.map((doc) => doc.Status);
    const uniqueStatuses = [...new Set(statuses)];

    if (uniqueStatuses.length > 1) {
        setErrorMessage(
          t(
            "⚠️ Several current statuses are present among the selected documents."
          )
        );
      setCurrentStatus(statuses[0]); 
    } else {
      setErrorMessage(""); 
    }

    setCurrentStatus(statuses[0]); 
  }
}, [documentIds, documentData]);

  const handleMassUpdate = async () => {
    setErrorMessage("");
    if (!currentStatus || !newStatus) {
      setErrorMessage(t("All fields must be completed."));
      return;
    }
    setLoading(true);
    try {
      const res = await updateStatusDocuments(
        currentStatus,
        newStatus,
        JSON.stringify(docList),
        token
      );
      setNbModified(res?.nbModified || docList.length);
      setToastOpen(true);
      setTimeout(() => window.location.reload(), 2000);
    } catch (error) {
      console.error("Erreur mise à jour documents :", error);
      setErrorMessage(t("An error occurred during the update."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <RelaunchToast
        isOpen={toastOpen}
        nbModified={nbModified}
        nbSelected={docList.length}
        onClose={() => setToastOpen(false)}
      />
      <div className="modal-container">
        <h3>{t("Update documents")}</h3>
        <p>{t("Change the status of a set of documents :")}</p>

        <label>{t("Current status :")}</label>
        <input
          type="text"
          value={currentStatus}
          onChange={(e) => setCurrentStatus(e.target.value)}
        />

        <label>{t("New status :")}</label>
        <input
          type="text"
          value={newStatus}
          onChange={(e) => setNewStatus(e.target.value)}
        />

        {errorMessage && (
          <div style={{ color: "red", marginTop: "10px" }}>{errorMessage}</div>
        )}

        <div className="modal-actions">
          <button
            className="btn_cancel"
            onClick={onClose}
            style={{ marginRight: "5px" }}
          >
            {t("Cancel")}
          </button>
          <button
            className="modal-button"
            onClick={handleMassUpdate}
            disabled={loading}
          >
            {loading ? t("Update ...") : t("To update")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RelaunchDoc;
